// eslint-disable-next-line import/extensions
import { createColumnFactory } from '@/AgGridComponents/columnFactory';

export function buildProcessChargesTripsColumns(vm) {
    const col = createColumnFactory();
    return [
        // Default visible
        col({
            headerName: '',
            checkboxSelection: true,
            headerComponent: 'PageHeaderCheckbox',
            minWidth: 50,
            maxWidth: 50,
            lockPosition: 'left',
            sortable: false,
            filter: false,
            suppressMenu: true,
            resizable: false
        }),
        col({
            headerName: 'Trip Reference',
            field: 'tripReference',
            type: 'text',
            width: 180,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer('Trip Details', { tripId: params.data.tripId }, params.value)
        }),
        col({
            headerName: 'Trip Date',
            field: 'tripDate',
            type: 'date',
            valueFormatter: vm.$_dateFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Customer',
            field: 'customerName',
            type: 'boolean',
            width: 180,
            keyCreator: (params) => (params.value ? params.value.name : ''),
            filterParams: {
                values: vm.loadCustomerList,
                valueFormatter: (params) => (params.value ? params.value.name : ''),
                selectAllOnMiniFilter: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Team Member',
            field: 'driverName',
            type: 'boolean',
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Team Member Profile',
                    { publicUserId: params.data.driverPublicUserId },
                    params.value
                ),
            keyCreator: (params) => (params.value ? params.value.fullName : ''),
            filterParams: {
                values: vm.loadTeamMembers,
                valueFormatter: (params) => (params.value ? params.value.fullName : ''),
                selectAllOnMiniFilter: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Costs Approved',
            field: 'isCostsApproved',
            type: 'boolean',
            valueFormatter: vm.$_booleanFormatter,
            keyCreator: (params) => {
                if (params.value === 'Yes') {
                    return 'true';
                }
                if (params.value === 'No') {
                    return 'false';
                }
                return 'true';
            },
            filterParams: {
                values: ['Yes', 'No'],
                valueFormatter: (params) => (params.value ? params.value : ''),
                suppressMiniFilter: true,
                suppressSelectAll: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Charges Approved',
            field: 'isChargesApproved',
            type: 'boolean',
            valueFormatter: vm.$_booleanFormatter,
            keyCreator: (params) => {
                if (params.value === 'Yes') {
                    return 'true';
                }
                if (params.value === 'No') {
                    return 'false';
                }
                return 'true';
            },
            filterParams: {
                values: ['Yes', 'No'],
                valueFormatter: (params) => (params.value ? params.value : ''),
                suppressMiniFilter: true,
                suppressSelectAll: true
            }
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Hours',
            field: 'hours',
            type: 'number',
            width: 110,
            valueFormatter: vm.$_decimalFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Net Charge',
            field: 'nettCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter
        }), // [AgGridDefaultVisible]
        col({
            headerName: 'Net Cost',
            field: 'nettCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter
        }), // [AgGridDefaultVisible]
        // Hidden by default
        col({
            headerName: 'Run Name',
            field: 'runName',
            type: 'boolean',
            hide: true,
            keyCreator: (params) => (params.value ? params.value.runName : ''),
            filterParams: {
                values: vm.loadRunsList,
                valueFormatter: (params) => (params.value ? params.value.runName : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({ headerName: 'Run #', field: 'runNumber', type: 'number', width: 110, hide: true }),
        col({
            headerName: 'Team Region Name',
            type: 'boolean',
            field: 'teamRegionId',
            valueFormatter: (params) => {
                return params.data.teamRegionName
            },
            keyCreator: (params) => (params.value ? String(params.value.teamRegionId) : ''),
            filterValueGetter: (params) => params.data.teamRegionId,
            filterParams: {
                values: vm.loadTeamRegions,
                valueFormatter: (params) => {

                    return params.value ? params.value.name : '';
                },
                selectAllOnMiniFilter: true
            },
        }),
        col({
            headerName: 'Team Region Code',
            field: 'teamRegionCode',
            type: 'boolean',
            hide: true,
            keyCreator: (params) => {
                if (params.value != null && params.value.teamRegionId == null) {
                    return null;
                }
                return params.value ? params.value.teamRegionCode : null;
            },
            filterParams: {
                values: vm.loadTeamRegionCode,
                valueFormatter: (params) => (params.value ? params.value.teamRegionCode : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Actual Started',
            field: 'actualStartTime',
            type: 'text',
            valueFormatter: vm.$_timeFormatter,
            hide: true,
            floatingFilter: false
        }),
        col({
            headerName: 'Actual Completed',
            field: 'actualEndTime',
            type: 'text',
            valueFormatter: vm.$_timeFormatter,
            hide: true,
            floatingFilter: false
        }),
        col({
            headerName: 'Last Stop Completion',
            field: 'lastStopCompletion',
            type: 'date',
            valueFormatter: vm.$_timeFormatter,
            hide: true,
            floatingFilter: false
        }),
        col({
            headerName: 'Scheduled Start',
            field: 'scheduledStartTime',
            valueFormatter: vm.$_timeFormatter,
            type: 'text',
            floatingFilter: false
        }),
        col({
            headerName: 'Scheduled End',
            field: 'scheduledEndTime',
            valueFormatter: vm.$_timeFormatter,
            type: 'text',
            floatingFilter: false
        }),
        col({ headerName: 'Start Address', field: 'startAddress', type: 'text', width: 220, hide: true }),
        col({ headerName: 'End Address', field: 'endAddress', type: 'text', width: 220, hide: true }),
        col({
            headerName: 'Service Package',
            field: 'rateGroupNameCosts',
            type: 'boolean',
            width: 170,
            keyCreator: (params) => {
                if (params.value != null && params.value.rateGroupId == null) {
                    return null;
                }
                return params.value ? params.value.rateGroupName : null;
            },
            filterParams: {
                values: vm.loadServicePackageList,
                valueFormatter: (params) => (params.value ? params.value.rateGroupName : ''),
                selectAllOnMiniFilter: true
            }
        }),
        col({
            headerName: 'Team Member Invoice #',
            field: 'teamMemberInvoiceNumber',
            type: 'text',
            width: 190,
            hide: true,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Team Member Invoice Details',
                    { invoiceId: params.data.teamMemberInvoiceId },
                    params.value
                )
        }),
        col({
            headerName: 'Customer Invoice #',
            field: 'customerInvoiceNumber',
            type: 'text',
            width: 190,
            hide: true,
            cellRenderer: 'LinkRenderer',
            cellRendererParams: (params) =>
                vm.$_linkCellRenderer(
                    'Customer Invoice Details',
                    { invoiceId: params.data.customerInvoiceId },
                    params.value
                )
        }),
        col({
            headerName: 'Hours Charged',
            field: 'hoursCharged',
            type: 'number',
            valueFormatter: vm.$_decimalFormatter,
            hide: true
        }),
        col({
            headerName: 'Charge / Hr',
            field: 'chargePerHour',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Base Charge',
            field: 'baseCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Fuel Levy Charge',
            field: 'fuelLevyCharge',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Driver Hours',
            field: 'driverHours',
            type: 'number',
            valueFormatter: vm.$_decimalFormatter,
            hide: true
        }),
        col({
            headerName: 'Hours Costed',
            field: 'hoursCosted',
            type: 'number',
            valueFormatter: vm.$_decimalFormatter,
            hide: true
        }),
        col({
            headerName: 'Cost / Hr',
            field: 'costPerHour',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Base Cost',
            field: 'baseCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Fuel Levy Cost',
            field: 'fuelLevyCost',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            hide: true
        }),
        col({
            headerName: 'Margin',
            field: 'margin',
            type: 'currency',
            valueFormatter: vm.$_currencyFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Margin %',
            field: 'marginPercent',
            type: 'percent',
            valueFormatter: vm.$_percentFormatter,
            width: 120,
            hide: true
        }),
        col({
            headerName: 'Actions',
            cellRenderer: 'ActionRendererProcessCharges',
            cellRendererParams: (params) =>
                vm.$_actionParameterCellRenderer(params, 'trip', vm.triggerRecalculate.bind(vm), vm.fetchTrip.bind(vm)),
            sortable: false,
            width: 200,
            pinned: 'right'
        })
    ];
}

export default buildProcessChargesTripsColumns;
